import { IconSetUnawareIcon } from "@/types/icons";
import { left, Either, right } from "fp-ts/lib/Either";
import { catchAndLogExceptions } from "@/util/prevent-exceptions";
import slugify from "slugify";

function getTitleFromSvg(svg: SVGSVGElement) {
  const maybeTitle = svg.querySelector("title");
  return maybeTitle ? maybeTitle.innerHTML : null;
}

export const icomoonSvgDefsToIcons = catchAndLogExceptions(
  (icomoonSvgDefsXml: string): Either<string[], IconSetUnawareIcon[]> => {
    const domParser = new DOMParser();

    const doc = domParser.parseFromString(
      icomoonSvgDefsXml,
      "application/xhtml+xml" /* is this the right type? */
    );

    const symbols = doc.querySelectorAll(
      "defs > symbol"
    ) as NodeListOf<SVGSymbolElement>;

    if (symbols.length < 1) {
      return left(["no SVGs found - are you sure you uploaded a valid file?"]);
    }

    return right(
      Array.from(symbols).map(symbol => {
        return {
          slug: symbol.id,
          name: symbol.id /* or does icomoon export the title somehow? */,
          svgCode: symbol.outerHTML.replace(/symbol/g, "svg")
        };
      })
    );
  }
);

export const svgToIcon = catchAndLogExceptions(
  (
    svgString: string,
    originalFilename: string
  ): Either<string[], IconSetUnawareIcon> => {
    const domParser = new DOMParser();

    const doc = domParser.parseFromString(
      svgString,
      "application/xhtml+xml" /* is this the right type? */
    );

    const svg = doc.querySelector("svg");

    if (!svg) {
      return left(["No SVG element found."]);
    }

    const filename = originalFilename
      .replace(/\.svg|icon-/g, "")
      .replaceAll("-", " ");

    const svgTitle = getTitleFromSvg(svg);
    const slug = svgTitle ? slugify(svgTitle) : "icon-" + slugify(filename);
    const name = svgTitle ? svgTitle : filename;

    return right({
      slug,
      name,
      svgCode: svg.outerHTML
    });
  }
);
